// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"965":"home-lang-el","3895":"home-lang-en"}[chunkId] + "-legacy." + {"965":"a32ad11e","3895":"ef43b0ce"}[chunkId] + ".js";
};